/*
 * MCRO001-F0050 / T-MCRO-050 (design: choreo MCRO001-D004 §§4.1.3/7 picker)
 * Slice 2 of 3 — the dispatcher.
 *
 * Does the registry lookup by `node.kind` and renders the node with the resolved
 * renderer (§4.3): `getRenderer(node.kind)` returns the well-known renderer or
 * UnknownKindBox for an unregistered kind. `node.title` is shown on the box border by
 * each renderer. `onResolve(id, resolution)` is forwarded to the resolving renderers;
 * read-only viewers ignore it. `readOnly` forces the read-only path (viewer-tier,
 * D004 §5.3) — a viewer can never resolve.
 *
 * GENERIC: the ONLY choreography-adjacent thing here is nothing — it takes a node and a
 * callback. The same dispatcher serves merge conflicts, review comments and suggestions.
 */

import React from 'react';
import { getRenderer } from '../../lib/annotation/annotationRegistry';

/**
 * @typedef {Object} AnnotationPickerProps
 * @property {import('../../lib/annotation/annotationNode').AnnotationNode} node
 * @property {(id: string, resolution: import('../../lib/annotation/annotationNode').AnnotationNode['resolution']) => void} [onResolve]
 * @property {boolean} [readOnly]
 * @property {() => string} [mintId]  id generator (injected in tests)
 */

/**
 * @param {AnnotationPickerProps} props
 */
export default function AnnotationPicker({ node, onResolve, readOnly = false, mintId }) {
  if (!node || typeof node.kind !== 'string') return null;
  const Renderer = getRenderer(node.kind);
  return <Renderer node={node} onResolve={onResolve} readOnly={readOnly} mintId={mintId} />;
}
